const searchCompare = new Intl.Collator('en', {
    usage: 'search',
    ignorePunctuation: true,
    sensitivity: 'base'
}).compare

export function isSubstring(haystack: string, needle: string): boolean {
    if (needle.length > haystack.length) {
        return false
    }

    for (let base = 0; base <= haystack.length - needle.length; base++) {
        const compareResult = searchCompare(haystack.substr(base, needle.length), needle)
        if (compareResult === 0) {
            return true
        }
    }

    return false
}
